import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData} from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

const MainTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="voting/challenged-asset-committees"
    sortable={["Created On"]}
  />;
};

const addFormFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Organization", "voting/list-fund-and-loancomany-orgs", { name: "organizationId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Contact", "orgs/list-organization-contacts", { name: "organizationContactId", required: true, dependencyField: "organizationId" })]);
  return myForm;
};

const AddMemberForm = () => {
  const myForm = addFormFields(new BCFormController({}, { submitSuffix: "voting/challenged-asset-committees" })); 
  const formActions = ["save-new", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const EditMemberForm = ({ id }) => {
  const editRecordSuffix = `${id}`;
  const deleteSuffix = "voting/challenged-asset-committees";
  const [{ data = {}, isLoading, error }] = useFetchData(`voting/challenged-asset-committees/${editRecordSuffix}`);
  const myForm = addFormFields(new BCFormController(data, { submitSuffix: "voting/challenged-asset-committees", clearSuffixesOnSubmit: [editRecordSuffix],deleteSuffix }));
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions} />;
};

const LmsVotingCACMembers = ({ params = {}, history }) => {
  const allowedActions = ["add"];
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params, allowedActions);
  if (!isActionAllowed) {
      history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <MainTable />}
    {isAdd && <AddMemberForm />}
    {isEdit && <EditMemberForm id={id} />}
  </React.Fragment>);
};

export default LmsVotingCACMembers;